import { Outlet, createFileRoute } from '@tanstack/react-router'
import { Fade } from '@/components/animate-ui/primitives/effects/fade'
import { Slide } from '@/components/animate-ui/primitives/effects/slide'

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Left Panel - Gradient Background with Branding */}
      <div className="relative w-full md:w-1/2 min-h-[40vh] md:min-h-screen flex items-center justify-center p-8 md:p-12 overflow-hidden bg-gradient-to-b from-[#132e3f] via-[#7bbd91] to-[#5a9b7d]">
        {/* Content over gradient */}
        <div className="relative z-10 text-center md:text-left max-w-lg">
          <Fade inView delay={0}>
            <div className="mb-8 flex justify-center md:justify-start">
              <img
                src={`${import.meta.env.BASE_URL.replace(/\/$/, '')}/q3-advisors-logo-dark.webp`}
                alt="Q3 Advisors"
                className="h-auto w-48 md:w-56 object-contain drop-shadow-lg"
              />
            </div>
          </Fade>
          <Slide direction="down" inView delay={100}>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 text-white">
              Welcome
            </h1>
          </Slide>
          <Slide direction="down" inView delay={200}>
            <p className="text-lg md:text-xl text-white/90 leading-relaxed">
              Sign in to access your account and manage your financial planning
              with confidence.
            </p>
          </Slide>
        </div>
      </div>

      {/* Right Panel - Login Form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-6 md:p-12 bg-background">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
